import { createSelector } from 'reselect'

import {
  networkGroup,
} from './utils'

const projects = state => state.project.projects
const userRole = state => state.project.userRole
const users = state => state.project.users
const currentProjectId = state => state.project.currentProjectId

const currentProject = createSelector(
  projects,
  currentProjectId,
  (projects, id) => (projects || []).find(p => p.id == id || p.url == id)
)

const currentProjectStripeConnect = createSelector(
  currentProject,
  (project) => project ? project.stripe_connect : null,
)

const selectors = {
  projects,
  users,
  userRole,
  currentProjectId,
  currentProject,
  currentProjectStripeConnect,
  ...networkGroup('project', [
    'loadAdminProjects',
    'loadPublicProjects',
  ])
}

export default selectors
